import React, { useEffect, useState } from 'react';
import { ConversationType, Product } from '../../../const';
import { checkTime, createHandle, getProductImage, toMoney } from '@/libs/app';
import { DiscountStatus, PagePath, PriceSymbol, ProductStatus } from '@/layouts/shared';
import {
  Icon,
  XNewIcon,
  Image,
  Button,
  WalletIcon,
  Link,
  ButtonVariant,
  ChatLineIcon,
  PentagonIcon,
} from '@/components';
import { useCreateChatConversation, useFetchProductLiveIdQuery } from '../../../api';
import { TFunction } from 'next-i18next';
import { useFetchConversationByProductQuery } from '@/features/products/detail/api';
import { useCreateOrderChat } from '@/features/consults/chat/api';
import { getAuth } from '@/libs/cookies';
type ProductsProps = {
  userId: number;
  onClose: () => void;
  liveId: string | number;
  t: TFunction;
  sendComment: (code: string) => void;
};
const Products = ({ onClose, liveId, t, userId, sendComment }: ProductsProps) => {
  const { isAuth } = getAuth();
  const [products, setProducts] = useState<Product[]>([]);
  const [p, setP] = useState<Product>();
  const { refetch } = useFetchProductLiveIdQuery(liveId, {
    onSuccess: ({ data }) => {
      setProducts(data);
    },
  });
  const { mutate: sendMessage } = useCreateOrderChat({});
  const { refetch: fetchConversation, isLoading: isFetchConversationLoading } =
    useFetchConversationByProductQuery(p?.id || 0, {
      retry: 0,
      enabled: false,
      onSuccess: (data) => {
        const { id, type_code, type } = data.data || {};
        sendMessage({
          id: id,
          data: {
            content: `TV ${type_code}`,
            images: [],
            type: 'text',
          },
        });
      },
      onError: () => {
        return mutate({
          title: p?.product_name || '',
          type_id: p?.id || 0,
          type_image: getProductImage(p?.images) || '',
          type_code: p?.product_code || '',
          type: ConversationType.Product,
        });
      },
    });
  const { mutate, isLoading: isCreateChatConversationLoading } = useCreateChatConversation({
    onSuccess: ({ data }) => {
      const { conversation } = data;
      sendMessage({
        id: conversation.id,
        data: {
          content: `TV ${conversation.type_code}`,
          images: [],
          type: 'text',
        },
      });
    },
    onError: ({ message }) => {},
  });
  const onConsultClick = (p: Product) => {
    if (p.id) {
      setP(p);
    }
  };
  useEffect(() => {
    if (p?.id) fetchConversation();
  }, [fetchConversation, p?.id]);
  useEffect(() => {
    refetch();
  }, [liveId, refetch]);
  const handleSendMessage = (p: Product) => {
    onConsultClick(p);
    sendComment(p.product_code);
  };
  return (
    <div className="tw-relative tw-w-full tw-h-full tw-flex tw-flex-col tw-rounded-lg tw-bg-white">
      <div className="tw-flex tw-px-3 tw-py-1 tw-border-b  tw-items-center tw-justify-between">
        <span className="tw-text-base tw-font-semibold">Sản phẩm trong Livestream</span>
        <div className="tw-cursor-pointer" onClick={onClose}>
          <Icon icon={<XNewIcon />} className="tw-w-6 tw-h-6" />
        </div>
      </div>
      <div className="tw-mt-2  tw-overflow-y-auto">
        <div className=" tw-flex tw-flex-col tw-h-full">
          {products.length > 0 ? (
            products.map((p, i) => {
              let isDiscount = p.product_discount
                ? checkTime(p.product_discount?.started_at, p.product_discount?.ended_at)
                : false;
              if (p?.product_discount && p.product_discount?.status === DiscountStatus.Ended)
                isDiscount = false;
              const isDeposited =
                p.quantity <= 0 ||
                p.status == ProductStatus.CloseASale ||
                p.status === ProductStatus.Deposited;
              let handle = `${createHandle(p.product_name)}-${p.id}-${p.product_code}`;
              return (
                <>
                  <div
                    className={`tw-flex tw-gap-2 tw-p-2 ${i < products.length && 'tw-border-b'}`}
                  >
                    <div className="tw-w-[54px] tw-h-[54px] tw-relative tw-leading-0 tw-bg-secondary-20 tw-z-0">
                      <Image
                        className="tw-w-full tw-h-full !tw-absolute tw-z-1 tw-top-0 tw-left-0 tw-bottom-0"
                        alt={p.product_name}
                        src={p.images && p.images[0] ? p.images[0].url : '/bg-default.png'}
                      ></Image>
                      {p.product_discount && isDiscount && (
                        <>
                          <div className="tw-w-4 tw-h-4 tw-absolute tw-top-1 tw-right-1 tw-z-10">
                            <Image
                              src="/sale.png"
                              className="tw-w-full tw-h-full"
                              alt="sale"
                            ></Image>
                          </div>
                        </>
                      )}
                      {p.is_auction && (
                        <>
                          <div className="tw-w-4 tw-h-4 tw-absolute tw-top-1 tw-right-1 tw-z-10">
                            <Image
                              src="/auction.png"
                              className="tw-w-full tw-h-full"
                              alt="auction"
                            ></Image>
                          </div>
                        </>
                      )}
                    </div>
                    <div className="tw-flex tw-flex-col tw-flex-1">
                      <Link
                        url={{ pathname: PagePath.ProductDetailPage, query: { id: handle } }}
                        target="_black"
                        className="tw-line-clamp-1 tw-text-primary-main tw-text-xs tw-leading-4 tw-font-bold"
                      >
                        {p?.product_name}
                      </Link>
                      <div className="">
                        {!p.quotation ? (
                          <div className="tw-text-secondary-70 tw-flex tw-flex-col">
                            <span className="tw-text-xs">{p.product_code}</span>

                            {p.product_discount && isDiscount ? (
                              <div className="tw-flex">
                                <span className="tw-text-warning-90 tw-font-medium tw-text-13">
                                  {toMoney(
                                    p.price - (p.price * p.product_discount?.discount) / 100,
                                    t
                                  )}
                                </span>
                                <span>&nbsp;~&nbsp;</span>
                                <span className="tw-text-primary-main tw-font-medium tw-text-13">
                                  {toMoney(
                                    p.token - (p.token * p.product_discount?.discount) / 100,
                                    t,
                                    PriceSymbol.Atd
                                  )}
                                </span>
                              </div>
                            ) : (
                              <div className="tw-flex tw-text-xs tw-items-center lg:tw-gap-x-1">
                                <span className="tw-text-warning-90 tw-font-medium tw-text-xs">
                                  {toMoney(p.price, t)}
                                </span>
                                <span>&nbsp;~&nbsp;</span>
                                <span className="tw-text-primary-main tw-font-medium tw-text-xs">
                                  {toMoney(p.token, t, PriceSymbol.Atd)}
                                </span>
                              </div>
                            )}
                          </div>
                        ) : (
                          <>
                            <div className="tw-text-secondary-70">
                              <span className="tw-text-xs">{p.product_code}</span>
                              <div className="tw-text-warning-90">{t('layout:btn.contact')}</div>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                    {isAuth && (
                      <div className="tw-flex tw-items-center tw-justify-center tw-flex-col tw-gap-y-2">
                        <Button
                          disabled={!userId || p.quantity <= 0}
                          onClick={() => handleSendMessage(p)}
                          className="!tw-flex tw-items-center tw-justify-center !tw-w-max lg:!tw-w-[125px]  tw-text-xs !tw-rounded-5 tw-py-1 tw-px-3 sm:tw-w-1/2 tw-h-[34px]"
                          variant={ButtonVariant.Outlined}
                        >
                          <Icon
                            icon={<ChatLineIcon />}
                            className="tw-w-3 tw-h-3 tw-mr-3 lg:tw-mr-2 xl:tw-mr-3"
                          />
                          {t('layout:btn.consult')}
                        </Button>
                        {!p.is_auction && (
                          <>
                            {p.quotation ? (
                              <>
                                <div className="tw-w-full tw-flex tw-justify-start tw-mt-6">
                                  <Button
                                    disabled={p.status !== ProductStatus.Availability}
                                    onClick={() => onConsultClick(p)}
                                    className="tw-flex tw-items-center tw-justify-center !tw-w-max lg:!tw-w-[125px]  tw-text-xs !tw-rounded-5 tw-py-1 tw-px-3 sm:tw-w-1/2 tw-text-warning-90 tw-border-warning-90 tw-h-[34px]"
                                    variant={ButtonVariant.Outlined}
                                  >
                                    <div className="tw-flex tw-gap-x-4 tw-justify-center">
                                      Liên hệ
                                    </div>
                                  </Button>
                                </div>
                              </>
                            ) : (
                              <>
                                {p.quantity <= 0 || p.status != ProductStatus.Availability ? (
                                  <Button
                                    disabled
                                    className="!tw-rounded-5 tw-text-white tw-bg-primary-main  tw-py-1 tw-px-3 tw-flex tw-items-center tw-justify-center !tw-w-max lg:!tw-w-[125px] tw-uppercase tw-text-xs"
                                  >
                                    <Icon
                                      icon={<WalletIcon />}
                                      className="tw-w-3 tw-h-3 tw-mr-1 tw-text-white"
                                    />
                                    {t('layout:btn.deposited')}
                                  </Button>
                                ) : (
                                  <Link
                                    url={{
                                      pathname: PagePath.ProductDepositPage,
                                      query: { id: p.id, stream_id: liveId },
                                    }}
                                    target="_blank"
                                    className="tw-bg-primary-main !tw-text-white !tw-w-max lg:!tw-w-[125px]  tw-gap-x-1 tw-border tw-px-3 tw-py-1 tw-rounded-5 tw-flex tw-items-center tw-justify-center tw-uppercase tw-text-xs "
                                  >
                                    <Icon
                                      icon={<WalletIcon />}
                                      className="tw-w-3 tw-h-3 tw-mr-1 tw-text-white"
                                    />
                                    <p>{t('layout:btn.order')}</p>
                                  </Link>
                                )}
                              </>
                            )}
                          </>
                        )}
                      </div>
                    )}
                  </div>
                </>
              );
            })
          ) : (
            <div className="tw-py-10 tw-text-lg tw-text-center">Không có sản phẩm</div>
          )}
        </div>
      </div>
    </div>
  );
};
export default Products;
